<template>
  <v-container class="py-12">
    <div class="text-center mb-12">
      <h1 class="text-h4 text-sm-h3">Mot de passe oublié</h1>

      <div class="subtitle-1 text--secondary mt-2">
        {{ step === 'email'
          ? 'Introduisez l\'adresse e-mail pour laquelle vous avez oublié votre mot de passe'
          : 'Introduisez un nouveau mot de passe pour votre compte'
        }}
      </div>
    </div>

    <v-card
      max-width="400"
      class="mx-auto rounded-lg"
    >
      <v-card-title class="justify-center">
        <v-img
          :src="require('@/assets/undraw_forgot_password_gi2d.svg')"
          height="100"
          contain
        ></v-img>
        {{ step === 'email' ? 'Retrouvez votre compte' : 'Modification du mot de passe' }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form" @submit.prevent="send">
          <v-text-field
            label="Adresse e-mail"
            v-model="email"
            :rules="rules.email"
            validate-on-blur
            :error-messages="emailErrorText"
            @change="emailErrorText = ''"
            outlined
            :disabled="loading"
            v-if="step === 'email'"
          ></v-text-field>

          <template v-else>
            <v-text-field
              label="Nouveau mot de passe"
              v-model="password"
              :rules="rules.password"
              validate-on-blur
              :type="passIsVisible ? 'text' : 'password'"
              :append-icon="passIsVisible ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="passIsVisible = !passIsVisible"
              outlined
              :disabled="loading"
            ></v-text-field>

            <v-text-field
              label="Confirmer"
              v-model="confirmPassword"
              :rules="rules.confirmPassword"
              validate-on-blur
              :type="passIsVisible ? 'text' : 'password'"
              :append-icon="passIsVisible ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="passIsVisible = !passIsVisible"
              outlined
            ></v-text-field>
          </template>

          <v-btn
            color="primary"
            block
            :loading="loading"
            x-large
            type="submit"
            :disabled="counter !== 31"
          >
            {{ step === 'email' ? 'Rechercher' : 'Modifier' }}
            {{ counter !== 31 ? `(${counter})` : '' }}
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import rulesMixin from '@/mixins/rulesMixin';

const axios = require('axios').default;

export default {
  name: 'ForgottenPassword',

  mixins: [rulesMixin],

  data: () => ({
    step: null,
    email: '',
    emailErrorText: '',
    loading: false,
    password: '',
    confirmPassword: '',
    passIsVisible: false,
    counter: 31,
  }),

  created() {
    if (this.$route.query.jeton) {
      this.step = 'password';
    } else {
      this.step = 'email';
    }
  },

  methods: {
    send() {
      if (!this.$refs.form.validate()) return;
      if (this.step === 'email') this.sendEmail();
      else this.changePassword();
    },

    async sendEmail() {
      try {
        this.loading = true;
        const response = await axios.post('mdp_oublie', { email: this.email });
        if (response.data === 'Email candidat non trouvé') {
          this.emailErrorText = 'L\'adresse e-mail n\'a pas été trouvée';
        } else {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: 'Un e-mail vous a été envoyé, consultez votre boite mail',
          });
          this.counter -= 1;
          const intv = setInterval(() => {
            this.counter -= 1;
            if (this.counter === 0) {
              clearInterval(intv);
              this.counter = 31;
            }
          }, 1000);
        }
      } catch (error) {
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Un problème est survenu, réessayez',
        });
      } finally {
        this.loading = false;
      }
    },

    async changePassword() {
      try {
        this.loading = true;
        const response = await axios.post('save_new_mdp', {
          password: this.password,
          password_confirmation: this.confirmPassword,
          jeton: this.$route.query.jeton,
        });
        if (response.data === 'Ok mot de passe réinitialisé') {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: 'Votre mot de passe a été modifié avec succès',
          });
          this.$router.push('/login');
        } else {
          this.$store.commit('SET_SNACKBAR', {
            isActive: true,
            text: response.data,
          });
        }
      } catch (error) {
        this.$store.commit('SET_SNACKBAR', {
          isActive: true,
          text: 'Un problème est survenu, réessayez',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
